import React, { Component } from 'react'
import { Button, Col, Row, Card, Form } from "react-bootstrap-v5";
import helperFunction from '../../../../Function/helperFunction'
import PackageModal from './PackageModal';
import MasterService from "../../../../Services/masterService";
import { retailerService } from "../../../../Services";

class AddOns extends Component {
    constructor() {
        super()
        this.state = {
            insuranceData: {},
            storageData: {},
            insuranceAmt: 0,
            storageAmt: 0,
            totalCharg: 0,
            totalFreight: 0,
            insurance_radio: 'no',
            storage_value: 0
        }
    }

    componentDidMount = () => {
        MasterService.get_insurance().then((result) => {
            if (result.status === true) {
                this.setState({ insuranceData: result.data[0] })
            }
        });

        MasterService.get_storage().then((result) => {
            if (result.status === true) {
                this.setState({ storageData: result.data })
            }
        });

        if (this.props?.addOns?.insurance?.insurance_amount) {
            this.setState({ insurance_radio: 'yes' });
        }
        this.setState({ storage_value: this.props?.addOns?.storage?.storage_value })
    }

    getRetailerDetailById = async () => {
        const { generalDetails } = this.props
        const retailerId = generalDetails.retailer_id ? generalDetails.retailer_id : generalDetails.sales_person ? generalDetails.sales_person._id : ''

        var disc = 0

        if (retailerId) {
            var disc = await retailerService.getRetailerDetails({ id: retailerId }).then((res) => {
                if (res.status) {
                    return res.data[0].customer_discount
                }
                return 0
            });
        } else {
            return disc
        }

    }

    handleInsuranceValue = (e) => {
        const { insuranceData } = this.state
        const { jobShipmentData } = this.props
        let insuranceValue = jobShipmentData.value_of_goods

        let insuranceAmt = helperFunction.calculateInsurancePer(
            insuranceData.insurance_premium,
            this.props.itemsBookingAmount,
            insuranceValue
        )
        insuranceAmt = insuranceAmt.toFixed(3)

        if (e.target.value === 'no') {
            insuranceValue = 0
            insuranceAmt = 99
        }

        this.setState({ insuranceAmt, insurance_radio: e.target.value }, () => {
            this.setActualAmount()
        })

        // this.props.onChangeValue({ name: 'items_goods', value: e.target.value }, 'add_ons', 'insurance')
        // this.props.onChangeValue({ value: Number(e.target.value) }, 'add_ons', 'insurance')
        this.props.onChangeValue({ name: 'insurance_amount', value: Number(insuranceValue) }, 'add_ons', 'insurance')
        this.props.onChangeValue({ name: 'insurance_premium', value: Number(insuranceData.insurance_premium) }, 'add_ons', 'insurance')
        this.props.onChangeValue({ name: 'minimum_aed', value: Number(insuranceData.minimum_aed) }, 'add_ons', 'insurance')
        
        this.props.onChangeValue({ value: e.target.value }, 'shipment_details', 'insurance_opted')

    }

    handleStorageValue = (e) => {
        const { storageData } = this.state
        const { jobData } = this.props
        let noOfDay, storageRate, volume, handlingIn, handlingOut

        noOfDay = e.target.value

        storageRate = storageData.storages.find(item => item.tarrif === 'storage_charges')

        handlingIn = storageData.storages.find(item => item.tarrif === 'handling_in')

        handlingOut = storageData.storages.find(item => item.tarrif === 'handling_out')

        let tempCopy = JSON.parse(JSON.stringify(jobData))
        let actualItems = tempCopy.length && tempCopy.map(item => item.actual)

        volume = actualItems.reduce((total, item) => Number(item.total_volume_CBM) + total, 0)

        let storageAmt = helperFunction.calculateStorage(noOfDay, storageRate.rate, volume, handlingIn.rate, handlingOut.rate)
        storageAmt = storageAmt.toFixed(3)

        this.setState({ storageAmt }, () => {
            this.setActualAmount()
        })
        this.setState({ storage_value: noOfDay })
        // this.props.onChangeValue({ name: 'storage_value', value: e.target.value }, 'add_ons', 'storage')
        // this.props.onChangeValue({ value: Number(e.target.value) }, 'add_ons', 'storage')
        this.props.onChangeValue({ name: 'storage_amount', value: Number(e.target.value) }, 'add_ons', 'storage')
        this.props.onChangeValue({ name: 'handling_in', value: Number(handlingIn.rate) }, 'add_ons', 'storage')
        this.props.onChangeValue({ name: 'handling_out', value: Number(handlingOut.rate) }, 'add_ons', 'storage')
        this.props.onChangeValue({ name: 'storage_charges', value: Number(storageRate.rate) }, 'add_ons', 'storage')

    }

    setActualAmount = () => {
        const { insuranceAmt, storageAmt, totalCharg, totalFreight } = this.state
        const { itemsBookingAmount, paymentInformation } = this.props
        console.log("paymentInformation .....", paymentInformation)
        var custDiscount = 0
        let pcCharge = totalCharg + totalFreight
        this.getRetailerDetailById().then(result => custDiscount = result)
        // console.log("custDiscount ....", custDiscount);
        let breakdown = {
            insurance: insuranceAmt ? insuranceAmt : paymentInformation.breakdown.insurance,
            storage: storageAmt ? storageAmt : paymentInformation.breakdown.storage,
            packing_charge: pcCharge ? pcCharge : paymentInformation.breakdown.packing_charge,
            freight: paymentInformation.breakdown.freight,
            bookingAmount: itemsBookingAmount ? itemsBookingAmount : paymentInformation.breakdown.bookingAmount,
            discount_amount: paymentInformation.breakdown.discount_amount,
        }
        // console.log("breakdown .....", breakdown);
        let totalAmt = Number(breakdown.insurance)
            + Number(breakdown.storage)
            + Number(breakdown.packing_charge)
            + Number(paymentInformation.breakdown.freight)

        let discount = custDiscount ? (totalAmt * custDiscount) / 100 : 0
        breakdown.discount_amount = discount.toFixed(3)
        let bamt = totalAmt - discount;

        this.props.onChangeValue({ value: totalAmt.toFixed(3) }, 'payment_information', 'actual_amount')
        this.props.onChangeValue({ value: bamt.toFixed(3) }, 'payment_information', 'booking_amount')
        this.props.onChangeValue({ value: breakdown }, 'payment_information', 'breakdown')
    }

    manageActualAmt = (totalCharg, totalFreight) => {
        this.setState({ totalCharg, totalFreight })

        const { itemsBookingAmount, paymentInformation } = this.props
        const { insuranceAmt, storageAmt } = this.state
        var custDiscount = 0
        let pcCharge = totalCharg + totalFreight
        this.getRetailerDetailById().then(result => custDiscount = result)
        let breakdown = {
            insurance: insuranceAmt ? insuranceAmt : paymentInformation.breakdown.insurance,
            storage: storageAmt ? storageAmt : paymentInformation.breakdown.storage,
            packing_charge: pcCharge ? pcCharge : paymentInformation.breakdown.packing_charge,
            freight: paymentInformation.breakdown.freight,
            bookingAmount: itemsBookingAmount ? itemsBookingAmount : paymentInformation.breakdown.bookingAmount,
            discount_amount: paymentInformation.breakdown.discount_amount,
        }
        let totalAmt = Number(breakdown.insurance)
            + Number(breakdown.storage)
            + Number(breakdown.packing_charge)
            + Number(paymentInformation.breakdown.freight)

        let discount = custDiscount ? (totalAmt * custDiscount) / 100 : 0
        breakdown.discount_amount = discount.toFixed(3)

        let bamt = totalAmt - discount;

        this.props.onChangeValue({ value: totalAmt.toFixed(3) }, 'payment_information', 'actual_amount')
        this.props.onChangeValue({ value: bamt.toFixed(3) }, 'payment_information', 'booking_amount')
        this.props.onChangeValue({ value: breakdown }, 'payment_information', 'breakdown')
    }

    render() {

        const {
            addOns,
            jobData,
            jobCargoData,
            jobShipmentData,
            quoteToken,
            originData,
            destinationData,
            paymentInformation,
            formValidator,
            onChangeValue,
            prevItemCount,
            itemsBookingAmount,
        } = this.props

        if (!jobData || Object.keys(jobData).length === 0) return false

        return (
            <div className="card">

                <div className="card-header bg-light"><h4>Select Add-On (if require)</h4></div>
                <div className="card-body">
                    <div className="row">
                        <div className="mb-3 col-md-3 col-12">
                            <div className="pt-3">
                                <PackageModal
                                    isview={this.props.isview}
                                    packingItem={jobData}
                                    jobCargoData={jobCargoData}
                                    jobShipmentData={jobShipmentData}
                                    originData={originData}
                                    destinationData={destinationData}
                                    quoteToken={quoteToken}
                                    paymentInformation={paymentInformation}
                                    prevItemCount={prevItemCount}
                                    onChangePack={onChangeValue}
                                    itemsBookingAmount={itemsBookingAmount}
                                    manageActualAmt={this.manageActualAmt}
                                />
                            </div>

                        </div>

                        <div className="mb-3 col-md-3 col-3">
                            <div className="mb-3">
                                <label className="form-label">Storage</label>
                                <input
                                    className="form-control form-control-sm"
                                    value={this.state.storage_value}
                                    onChange={(e) => this.handleStorageValue(e)}
                                />
                            </div>
                        </div>

                        <div className="mb-3 col-md-3 col-12">
                            <div className="mb-3">
                                <label className="form-label">Insurance</label>
                                <input
                                    className="form-control form-control-sm"
                                    readOnly
                                    // value={addOns.insurance.insurance_amount}
                                    value={jobShipmentData.value_of_goods}
                                // onChange={(e)=>this.handleInsuranceValue(e)}
                                />
                            </div>
                        </div>

                        <div className="mb-3 col-md-3 col-12">
                            <div className="position-relative me-2">
                                <label className="form-label">Calculate Insurance</label>
                                <div key={`inline-radio`} className="mb-3">
                                    <Form.Check
                                        inline
                                        label="Yes"
                                        name="insurance_radio"
                                        value="yes"
                                        type="radio"
                                        id={`inline-radio-1`}
                                        checked={this.state.insurance_radio === 'yes'}
                                        onChange={(e) => this.handleInsuranceValue(e)}
                                    />
                                    <Form.Check
                                        inline
                                        label="No"
                                        name="insurance_radio"
                                        value="no"
                                        type="radio"
                                        id={`inline-radio-2`}
                                        checked={this.state.insurance_radio === 'no'}
                                        onChange={(e) => this.handleInsuranceValue(e)}
                                    />

                                </div>
                            </div>
                        </div>



                    </div>

                    <div className='row'>
                        <div className="col-6">
                            <div className="">
                                <label className="form-label">Comment</label>
                                <textarea
                                    className="form-control form-control-sm"
                                    value={jobData.comments}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AddOns